exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.webnone{display:none\n}\n.scrolltable{height:200px;overflow:scroll\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/modules/invoice/summary/footer.vue"],"names":[],"mappings":";AACA,SAAS,YAAY;CACpB;AACD,aAAa,aAAa,eAAe;CACxC","file":"footer.vue","sourcesContent":["\n.webnone{display:none\n}\n.scrolltable{height:200px;overflow:scroll\n}"],"sourceRoot":""}]);

// exports
